// extracted by mini-css-extract-plugin
export var inlineLink = "_3w-0";
export var inlineLinkButton = "_3w-1";